<template>
    <div class="column-center wapp" :class="{'full':isFull,'kuan':iskuan}">
        <div class="column-center wapp" v-if="siteList.length>0">
            <div class="site">
                <span class="wiringItem" v-for="(item,index) in siteList" :key="index" :class="active==index?'active':''" @click="tagsite(index,item)">{{item.areaName}}</span>
                <div class="boxSite">
                    <span v-for="(item,index) in 3" :key="index + 10"></span>
                    <span>{{($store.getters.getTypeSite('photovoltaic')[active].areaName + ' ' + diagramDesc)}}</span>
                    <span v-for="(item,index) in 3" :key="index"></span>
                </div>
            </div>
            <div class="diagram">
                <iframe ref="iframe" height="100%" width="100%"  class="small" :src="wirsrc" frameborder="0"></iframe>
                <div class="handel">
                    <!-- <img src="@/assets/img/kuan.png" alt=""  v-if="!isFull"  @click="kuan"> -->
                    <img src="@/assets/img/quan.png" alt="" v-if="!iskuan"  @click="full">
                </div>
            </div>
            
            <div class="Wiring site" >
                <span class="wiringItem1" v-for="(item,index) in wiringList" :key="index" :class="active1==index?'active':''"  :title="item.diagramDesc" @click="tagsite1(index,item)">{{item.diagramDesc}}</span>
                <div class="box">
                    <span v-for="(item,index) in 10" :key="index"></span>
                </div>
            </div>
        </div>
        <div v-else class="row-center not_found_data">
            <img  src="../../../assets/img/not_found_data.png" alt="">
        </div>
    </div>
</template>

<script>

import { AreaAll,wiringByArea } from '../../../api/power'
export default {
    data(){
        return {
            isFull:false,
            iskuan: false,
            active:0,
            active1:0,
            siteList:[],
            wirsrc:"",
            wiringList:[],
            diagramDesc:""
        }
    },
    components:{
        
    },
    watch:{
		'$store.getters.areaId'(areaId){
            this.$store.getters.getTypeSite('distribution').forEach((item ,index) =>{
                if(item.areaId == areaId){
                    this.tagsite(index)
                }
            })
		}
	},
    computed:{
        "$store.state.project.currentProject.areaId"(n,o){
            this.getAreaAll()
        },
        "$store.getters.projectId"(n,o){
            this.getAreaAll()
        }
    },
    mounted(){
        this.getAreaAll()
    },
    methods:{
        tagsite1(index, item){
            this.active1 = index
            if(item){
                this.wirsrc = item.uploadFileUrl
                this.diagramDesc = item.diagramDesc
            }else{
                this.wirsrc = null
            }
        },
        getWiringByArea(areaId){
            wiringByArea({areaId:areaId}).then((res) => {
                let data = res.data.data.map(e=>{
                    return e.wirings[0]
                })
                if(data.length>0){
                    this.wiringList = data
                    // console.log(this.wiringList,"this.wiringList")
                    this.wirsrc = data[0].uploadFileUrl
                    this.diagramDesc = data[0].diagramDesc
                }else{
                    this.wiringList = []
                    this.wirsrc = ""
                    this.diagramDesc = ""
                }
            });
        },
        getAreaAll(){
            let obj = {
                projectId:this.$store.getters.projectId,
                areaType:2
            }
            AreaAll(obj).then((res) => {
                this.siteList = res.data.data
                this.getWiringByArea(res.data.data[0].areaId)
                
            });
        },
        tagsite(index,item){
            this.active = index
            this.active1 = 0
            this.getWiringByArea(item.areaId)
            this.$store.commit('setAreaId', this.$store.getters.getTypeSite('photovoltaic')[index].areaId)
            this.$store.commit("setAreaInfo", this.$store.getters.getTypeSite('photovoltaic')[index]);
        },
        kuan(){
            this.iskuan = !this.iskuan
        },
        full() {
            this.isFull = !this.isFull
        },
    }
}
</script>

<style lang="less" scoped>

        .wapp{
            width: 100%;
            height: 100%;
            background: #fff;
            justify-content: flex-start;
            position: relative;
            .not_found_data{
                height: 100%;
            }
        }
        .full {
            width: 100vw;
            height: 100vh;
            position: fixed;
            top: 0;
            left: 0;
            z-index: 9999;
        }

        .kuan {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 999;
        }
        .site{
            width: 100%;
            height: 40rem;
            position: relative;
            top: 0;
            left: 0;
            display: flex;
            flex-direction: row;
            // position: absolute;
            // top: 0;
            // left: 0;
            .wiringItem, .wiringItem1{
                background: #FFFFFF;
                border: 1px solid rgba(13, 148, 255, 0.15);
                border-radius: 4px;
                font-size: 16rem;
                font-weight: 500;
                color: #0E9CFF;
                display: inline-block;
                height: 40rem;
                text-align: center;
                line-height: 40rem;
                padding: 0 15rem;
                cursor: pointer;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                width: 10%;
                z-index: 11;
            }
            .box{
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                display: flex;
                flex-direction: row;
                &>span{
                    width: 10%;
                    height: 100%;
                    display: inline-block;
                    background: #FFFFFF;
                    border: 1px solid #0D94FF;
                    border-radius: 4px;
                    cursor: no-drop;
                }
            }
            .boxSite{
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                display: flex;
                flex-direction: row;
                &>span{
                    width: 10%;
                    height: 100%;
                    display: inline-block;
                    background: #FFFFFF;
                    border: 1px solid #0D94FF;
                    border-radius: 4px;
                    cursor: no-drop;
                }
                &>span:nth-child(4){
                    width: 40%;
                    background: #6DC8EC;
                    border-radius: 4px;
                    font-size: 16rem;
                    font-family: Source Han Sans SC;
                    font-weight: 800;
                    color: #FFFFFF;
                    line-height: 40rem;
                    text-align: center;
                    cursor: default;
                }
            }
            .active{
                background: #0E9CFF;
                color: #ffffff
            }
        }
        .Wiring{
            bottom: 0;
            top: auto
        }
        .diagram{
            // .h(566);
            height:calc(100% - 80rem);
            width: 100%;
            padding: 20rem;
            position: relative;
            .handel{
                position: absolute;
                bottom: 0;
                right: 10px;
                img{
                    margin:0 10rem;
                    cursor: pointer;
                }
            }
        }
</style>